import { COUNTRIES } from 'app/constants';
import { AddressEditorDropdownModule } from './addressEditorDropdown.directive';
import template from './addressEditor.html';

export const AddressEditorModule = angular
    .module('app.components.addressEditor', [
        AddressEditorDropdownModule
    ]).directive('addressEditor', () => {
        return {
            restrict: 'EA',
            scope: {
                address: '=',
                addressForm: '=formController'
            },
            template,
            link: function postlink(scope) {
                var unitedStates;
                angular.forEach(COUNTRIES, (country) => {
                    if (country.name === 'United States') unitedStates = country;
                });
                scope.states = unitedStates.states;
                scope.address = scope.address || {};
                scope.address.country = unitedStates.name;

                scope.onStateChanged = (chosenState) => {
                    scope.address.state = chosenState.code;
                };
            }
        };
    }).name;


// WEBPACK FOOTER //
// ./src/app/components/addressEditor/addressEditor.directive.js